export default __webpack_public_path__ + "static/media/phone.2c9ac21f.svg";